<template>
  <div>
    <top-bar @reload="buscarConfigs()"/>
    <div class="content">
      <div class="container-fluid pt-4">
        <modal-menu :menus="menus" :selected="menu" @changeMenu="toggleMenu"/>
        <loading v-show="load"/>
        <div v-show="!load">
          <div v-show="menu === 1">
            <div class="row">
              <div class="col-md-5" v-if="user.id_funcao <= 2">
                <div class="card mb-3">
                  <div class="card-body">
                    <div v-if="isElectron">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 class="m-0">Gestor Principal</h6>
                          <p class="mb-0 small">Ativar este computador como gestor principal de pedidos</p>
                        </div>
                        <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
                           @click="printServer = !printServer">
                          <span class="small mr-2">{{ printServer ? 'Ativado' : 'Desativado' }}</span>
                          <img class="switch" src="../../assets/icons/switch-on.svg" v-show="printServer" alt="Ativado"/>
                          <img class="switch" src="../../assets/icons/switch-off.svg" v-show="!printServer" alt="Desativado"/>
                        </a>
                      </div>
                    </div>
                    <div v-else>
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 class="m-0">Impressão Navegador / Bluetooth</h6>
                          <p class="mb-0 small">Ative apenas quando não usar impressora térmica.</p>
                        </div>
                        <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
                           @click="config.mobilePrint = config.mobilePrint === '1' ? '0' : '1'">
                          <span class="small mr-2">{{ config.mobilePrint !== '1' ? 'Desativado' : 'Ativado' }}</span>
                          <img class="switch" src="../../assets/icons/switch-on.svg" v-show="config.mobilePrint === '1'" alt="Ativado"/>
                          <img class="switch" src="../../assets/icons/switch-off.svg" v-show="config.mobilePrint !== '1'" alt="Desativado"/>
                        </a>
                      </div>
                      <hr>
                    </div>
                    <div v-if="printServer && isElectron">
                      <div class="row no-gutters mt-2">
                        <div class="col-md-6 mb-2 pr-md-1">
                          <label class="mb-0 small" for="impressoraPedidos">Impressora pedidos <a href="javascript:" @click="getPrinters()"><i class="fa fa-sync-alt ml-1"></i></a></label>
                          <select class="form-control" id="impressoraPedidos" v-model="config.device">
                            <option value="">Impressora padrão</option>
                            <option :value="p.displayName" v-for="p in printers">{{p.name}} {{p.isDefault ? ' (Padrão)' : ''}}</option>
                          </select>
                        </div>
                        <div class="col-md-6 mb-2 pl-md-1">
                          <label class="mb-0 small">Impressora comprovante</label>
                          <select class="form-control" v-model="config.devicePdv">
                            <option value="">Padrão do Gestor</option>
                            <option :value="p.displayName" v-for="p in printers">{{p.name}}</option>
                          </select>
                        </div>
                      </div>
                      <hr>
                    </div>
                    <div v-else-if="isElectron">
                      <hr>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="mr-2">
                          <h6 class="m-0">Impressão Local</h6>
                          <p class="mb-0 small">Imprima os pedidos ou comprovantes deste computador nas impressoras locais</p>
                        </div>
                        <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
                           @click="printRemoto = !printRemoto">
                          <span class="small mr-2">{{ !printRemoto ? 'Ativado' : 'Desativado' }}</span>
                          <img class="switch" src="../../assets/icons/switch-on.svg" v-show="!printRemoto" alt="Ativado"/>
                          <img class="switch" src="../../assets/icons/switch-off.svg" v-show="printRemoto" alt="Desativado"/>
                        </a>
                      </div>
                      <div class="row no-gutters mt-2" v-if="!printRemoto">
                        <div class="col-md-6 mb-2 pr-md-1">
                          <label class="mb-0 small">Impressora pedidos</label>
                          <select class="form-control" v-model="impressoraPedidos">
                            <option value="">Padrão do computador</option>
                            <option :value="p.displayName" v-for="p in printers">{{p.name}} {{p.isDefault ? ' (Default)' : ''}}</option>
                          </select>
                          <div class="small text-danger" v-if="impressoraPedidos && !printers.find(p => p.displayName === impressoraPedidos)">
                            {{ impressoraPedidos }} não encontrada
                          </div>
                        </div>
                        <div class="col-md-6 mb-2 pl-md-1">
                          <label class="mb-0 small">Impressora comprovante</label>
                          <select class="form-control" v-model="impressoraPdv">
                            <option value="">Padrão do computador</option>
                            <option :value="p.displayName" v-for="p in printers">{{p.name}} {{p.isDefault ? ' (Default)' : ''}}</option>
                          </select>
                          <div class="small text-danger" v-if="impressoraPdv && !printers.find(p => p.displayName === impressoraPdv)">
                            {{ impressoraPdv }} não encontrada
                          </div>
                        </div>
                      </div>
                      <hr>
                    </div>
                    <div v-else>
                      <div class="row no-gutters mt-2">
                        <div class="col-md-6 mb-2 pr-md-1">
                          <label class="mb-0 small" for="impressoraPedidos">Impressora pedidos</label>
                          <input class="form-control" :value="config.device || 'Padrão do computador'" disabled/>
                        </div>
                        <div class="col-md-6 mb-2 pl-md-1">
                          <label class="mb-0 small">Impressora comprovante</label>
                          <input class="form-control" :value="config.devicePdv || 'Padrão do Gestor'" disabled/>
                        </div>
                      </div>
                    </div>
                    <div class="row no-gutters" v-if="!isComanda">
                      <div class="col-lg-6 mb-2 pr-md-1">
                        <label class="mb-0 small" for="configAutomatica">Impressão automática</label>
                        <select class="form-control" id="configAutomatica" v-model="config.automatico">
                          <option value="1">Sim</option>
                          <option value="0">Não</option>
                        </select>
                      </div>
                      <div class="col-lg-6 mb-2 pl-md-1">
                        <label class="mb-0 small" for="nCopia">
                          Cópias (Apps)
                          <tooltip msg="Define quantas cópias serão impressas automaticamente na Impressora de Pedidos. Essa configuração é válida para: App/Site, Marketplaces (iFood, UaiRango, Aiq etc.) e Pedido Manual"/>
                        </label>
                        <select class="form-control" id="nCopia" v-model="config.nCopias" :disabled="config.automatico === '0'">
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                        </select>
                      </div>
                    </div>
                    <div class="row no-gutters">
                      <div class="col-md-6 mb-2 pr-md-1">
                        <label class="mb-0 small" for="zoom">Fonte</label>
                        <select class="form-control" id="zoom" v-model="config.zoom">
                          <option value="7px">1</option>
                          <option value="9px">2</option>
                          <option value="11px">3</option>
                          <option value="14px">4</option>
                        </select>
                      </div>
                      <div class="col-md-6 mb-2 pl-md-1">
                        <label class="mb-0 small" for="bobina">Bobina</label>
                        <select class="form-control" id="bobina" v-model="config.largura">
                          <option value="">Automático</option>
                          <option value="80mm">80mm</option>
                          <option value="75mm">75mm</option>
                          <option value="70mm">70mm</option>
                          <option value="60mm">60mm</option>
                          <option value="58mm">58mm</option>
                          <option value="50mm">50mm</option>
                          <option value="45mm">45mm</option>
                          <option value="40mm">40mm</option>
                          <option value="35mm">35mm</option>
                          <option value="30mm">30mm</option>
                        </select>
                      </div>
                      <div v-show="false" class="col-md-6 mb-2 pl-md-1">
                        <label class="mb-0 small" for="margin">Margem</label>
                        <select id="margin" v-model="config.margin" class="form-control">
                          <option value="auto">Automática</option>
                          <option value="0">Nenhuma</option>
                        </select>
                      </div>
                      <div class="col-md-12 my-2">
                        <div class="mb-1">Imprimir uma copia na Impressora de Pedidos</div>
                        <label class="d-block mb-0">
                          <input type="checkbox" :checked="config.printCashier === '1'" @change="config.printCashier = (config.printCashier === '1' ? '0' : '1')">
                          Pedidos Gestor / Delivery
                        </label>
                        <label>
                          <input type="checkbox" :checked="config.printCashierPdv === '1'" @change="config.printCashierPdv = (config.printCashierPdv === '1' ? '0' : '1')">
                          Pedidos PDV
                        </label>
                      </div>
                    </div>
                    <div class="text-center border-top mt-2 pt-3">
                      <button class="btn btn-dark btn-secondary px-4" @click="atualizarConfig">{{atualizar ? 'Salvo' : 'Salvar'}}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-7">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <div>
                        <h6 class="m-0">Notificações</h6>
                        <p class="mb-0 small">Emitir um alerta sonoro quando houver novos pedidos</p>
                      </div>
                      <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
                         @click="silenciar = !silenciar">
                        <span class="small mr-2 d-none d-md-inline-block">{{ silenciar ? 'Desativado' : 'Ativado' }}</span>
                        <img class="switch" src="../../assets/icons/switch-on.svg" v-show="!silenciar" alt="Ativado"/>
                        <img class="switch" src="../../assets/icons/switch-off.svg" v-show="silenciar" alt="Desativado"/>
                      </a>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="font-weight-bold small mb-1">Novos pedidos</label>
                        <div class="d-flex">
                          <select class="form-control mr-1" v-model="som_pedidos">
                            <option value="bell">Som 1</option>
                            <option value="bell-2">Som 2</option>
                            <option value="bell-3">Som 3</option>
                            <option value="bell-4">Som 4</option>
                            <option value="bell-5">Som 5</option>
                          </select>
                          <div><button class="btn btn-outline-dark" @click="playSom(1)" style="width: 48px"><i class="fa fa-play"></i></button></div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label class="font-weight-bold small mb-1">Notificações</label>
                        <div class="d-flex">
                          <select class="form-control mr-1" v-model="som_notificacao">
                            <option value="bell">Som 1</option>
                            <option value="bell-2">Som 2</option>
                            <option value="bell-3">Som 3</option>
                            <option value="bell-4">Som 4</option>
                            <option value="bell-5">Som 5</option>
                          </select>
                          <div><button class="btn btn-outline-dark" @click="playSom(2)" style="width: 48px"><i class="fa fa-play"></i></button></div>
                        </div>
                      </div>
                    </div>
                    <div class="text-center border-top pt-3 mt-3">
                      <button class="btn btn-dark btn-secondary px-4" @click="atualizarSom()">{{atualizar ? 'Salvo' : 'Salvar'}}</button>
                    </div>
                  </div>
                </div>
                <div class="card mb-3">
                  <div class="card-body">
                    <div v-if="!isComanda">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 class="m-0">Chat de Pedidos</h6>
                          <p class="mb-0 small">Habilitar o chat de pedidos do LeCard</p>
                        </div>
                        <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:" @click="toggleChatLecard">
                          <span class="small mr-2 d-none d-md-inline-block">{{ user.chat_lecard === '1' ? 'Ativado' : 'Desativado' }}</span>
                          <img class="switch" src="../../assets/icons/switch-on.svg" v-show="user.chat_lecard === '1'" alt="Ativado"/>
                          <img class="switch" src="../../assets/icons/switch-off.svg" v-show="user.chat_lecard !== '1'" alt="Desativado"/>
                        </a>
                      </div>
                      <hr>
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 class="m-0">Modo Lista</h6>
                          <p class="mb-0 small">Habilitar o gestor de pedidos no formato lista</p>
                        </div>
                        <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:" @click="toggleModoGestor">
                          <span class="small mr-2 d-none d-md-inline-block">{{ modoLista ? 'Ativado' : 'Desativado' }}</span>
                          <img class="switch" src="../../assets/icons/switch-on.svg" v-show="modoLista" alt="Ativado"/>
                          <img class="switch" src="../../assets/icons/switch-off.svg" v-show="!modoLista" alt="Desativado"/>
                        </a>
                      </div>
                      <hr>
                      <div v-if="isElectron">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 class="m-0">Tela do PDV</h6>
                            <p class="mb-0 small">
                              Abrir a tela do PDV em uma nova janela
                            </p>
                          </div>
                          <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
                             @click="toggleNewPage">
                            <span class="small mr-2 d-none d-md-inline-block">{{ openInNewPage ? 'Ativado' : 'Desativado' }}</span>
                            <img class="switch" src="../../assets/icons/switch-on.svg" v-show="openInNewPage" alt="Ativado"/>
                            <img class="switch" src="../../assets/icons/switch-off.svg" v-show="!openInNewPage" alt="Desativado"/>
                          </a>
                        </div>
                        <hr>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 class="m-0">Ocultar Módulo Gestor</h6>
                        <p class="mb-0 small">
                          Exibir apenas a comanda neste dispositivo
                        </p>
                      </div>
                      <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
                         @click="toggleHideGestor">
                        <span class="small mr-2 d-none d-md-inline-block">{{ hideGestor ? 'Ativado' : 'Desativado' }}</span>
                        <img class="switch" src="../../assets/icons/switch-on.svg" v-show="hideGestor" alt="Ativado"/>
                        <img class="switch" src="../../assets/icons/switch-off.svg" v-show="!hideGestor" alt="Desativado"/>
                      </a>
                    </div>
                    <hr>
                    <div>
                      <h6 class="m-0">Modo Terminal</h6>
                      <p class="mb-2 small">
                        Selecione o modelo de terminal deste dispositivo
                      </p>
                      <div style="max-width: 300px">
                        <select v-model="terminal" class="form-control" title="Habilitar Caixa" @change="toggleTerminal()">
                          <option value="">PDV</option>
                          <option value="1">Terminal de pesagem</option>
                          <option value="2">Auto terminal de pesagem</option>
                          <option value="3">Monitor de Preparo</option>
                          <option value="4">Monitor KDS</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <div class="mb-2">
                      <h6 class="m-0">{{user.nome}}</h6>
                      <div class="small">{{user.email}}</div>
                    </div>
                    <div>
                      <button class="btn btn-dark" @click="confirmLogout" style="width: 200px">Sair</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="menu === 2">
            <div class="row">
              <div class="col-md-7">
                <form @submit.prevent="salvarConfigsPdv()" autocomplete="off">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h5 class="mb-0">PDV</h5>
                    <div>
                      <button class="btn btn-secondary px-4">Salvar</button>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="small mb-0">Qtd de Mesas</label>
                            <input type="number" class="form-control" placeholder="Quantidade" v-model="configsPdv.qtd_mesas" min="1" max="127" required>
                            <div class="small mt-1">Mesas no salão</div>
                          </div>
                        </div>
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="small mb-0">Qtd de Comandas</label>
                            <input type="number" class="form-control" placeholder="Quantidade" v-model="configsPdv.qtd_comandas" min="1" max="127" required>
                            <div class="small mt-1">Comandas disponíveis</div>
                          </div>
                        </div>
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="small mb-0">Taxa de Entrega</label>
                            <money v-model="configsPdv.valor_frete" class="form-control mr-2" placeholder="Frete fixo"/>
                            <div class="small mt-1">Valor fixo de cada entrega</div>
                          </div>
                        </div>
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="small mb-0">Habilitar Caixas</label>
                            <select class="form-control" v-model="configsPdv.habilitar_caixa" title="Habilitar Caixa">
                              <option value="1">Sim</option>
                              <option value="0">Não</option>
                            </select>
                            <div class="small mt-1">Habilitar controle de caixa</div>
                          </div>
                        </div>
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="small mb-0">Importar LeCard</label>
                            <select class="form-control" v-model="configsPdv.importar_lecard" title="Importar LeCard">
                              <option value="1">Sim</option>
                              <option value="0">Não</option>
                            </select>
                            <div class="small mt-1">Importar pedidos LeCard</div>
                          </div>
                        </div>
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="small mb-0">Unidade medida</label>
                            <select class="form-control" v-model="configsPdv.unidade_medida" title="Unidade Medida">
                              <option value="1">Preço</option>
                              <option value="2">Kilo</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="mb-0 small">Senha Administrativa</label>
                            <div class="input-senha">
                              <input class="form-control" :class="{'inputAdm': !showSenha }" title="Senha" placeholder="Informe a senha" type="text" v-model="configsPdv.senha_pdv" autocomplete="off">
                              <i class="fa" :class="!showSenha ? 'fa-eye' : 'fa-eye-slash'" @click="showSenha = !showSenha" v-show="configsPdv.senha_pdv && configsPdv.senha_pdv.length" title="Mostra/esconder senha"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <h6 class="border-bottom pb-2 mt-3 mb-2">Impressão</h6>
                      <div class="row">
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-1">
                            <label class="small mb-0">
                              Impressão (PDV)
                              <tooltip :msg="'Define se o sistema deve perguntar antes de imprimir no PDV. A opção “Imprimir automático” imprime sem perguntar somente quando tiver uma cozinha vinculada ao pedido.'"/>
                            </label>
                            <select class="form-control" v-model="configsPdv.automatico">
                              <option value="0">Perguntar</option>
                              <option value="1">Imprimir automático</option>
                              <option value="2">Não imprimir</option>
                            </select>
                          </div>
                        </div>
                        <div v-if="configsPdv.json_config" class="col-6 col-lg-4">
                          <div class="form-group mb-1">
                            <label class="small mb-0">
                              Desmembrar itens
                              <tooltip msg="Imprime separadamente cada unidade de produtos com adicionais ou divisões no cupom do pedido."/>
                            </label>
                            <select v-model="configsPdv.json_config.desmembrar_itens" class="form-control">
                              <option value="1">Sim</option>
                              <option value="0">Não</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <h6 class="border-bottom pb-2 mt-3 mb-2">Taxas de Serviços</h6>
                      <div class="row">
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="small mb-0">Taxa de Serviço</label>
                            <select class="form-control" v-model="configsPdv.taxa_servico">
                              <option value="5">5%</option>
                              <option value="10">10%</option>
                              <option value="13">13%</option>
                              <option value="15">15%</option>
                              <option value="20">20%</option>
                              <option value="1">Sim (10%)</option>
                              <option value="0">Não</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="small mb-0">Estacionamento</label>
                            <money v-model="configsPdv.estacionamento" class="form-control mr-2" placeholder="Informe o valor"/>
                          </div>
                        </div>
                        <div class="col-6 col-lg-4">
                          <div class="form-group mb-2">
                            <label class="small mb-0">Couvert artístico</label>
                            <money v-model="configsPdv.cover" class="form-control mr-2" placeholder="Informe o valor"/>
                          </div>
                        </div>
                      </div>
                      <div v-if="configsPdv.json_config">
                        <h6 class="border-bottom pb-2 mt-3 mb-2">Aparência do Sistema</h6>
                        <div class="row">
                          <div class="col-6 col-lg-4">
                            <div class="form-group mb-2">
                              <label class="small mb-0">Lista de adicionais</label>
                              <select class="form-control" v-model="configsPdv.json_config.lista_adicionais">
                                <option value="1">Padrão</option>
                                <option value="2">Modo Simplificado</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-6 col-lg-4">
                            <div class="form-group mb-2">
                              <label class="small mb-0">Priorizar teclado <tooltip msg="Válido apenas para computadores. Faz com que o sistema seja mais intuitivo com o teclado do que com o toque na tela ou mouse."/></label>
                              <select class="form-control" v-model="configsPdv.json_config.priorizar_codigo">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-6 col-lg-4">
                            <div class="form-group mb-2">
                              <label class="small mb-0">Valor no pedido <tooltip msg="Mostrar os valores dos produtos e totais no cupom dos pedidos de mesas e comandas."/></label>
                              <select class="form-control" v-model="configsPdv.json_config.show_valor">
                                <option value="1">Mostrar valor</option>
                                <option value="0">Esconder valor</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-6 col-lg-4">
                            <div class="form-group mb-2">
                              <label class="small mb-0">Cortar fichas <tooltip msg="Cortar automaticamente a impressão das fichas de consumo."/></label>
                              <select v-model="configsPdv.json_config.cut_fichas" class="form-control">
                                <option value="1">Sim</option>
                                <option value="0">Não</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-6 col-lg-4">
                            <div class="form-group mb-2">
                              <label class="small mb-0">Campo Imposto NF-e</label>
                              <select class="form-control" v-model="configsPdv.json_config.imposto_nfe">
                                <option value="1">Habilitado</option>
                                <option value="0">Desativado</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-6 col-lg-4" v-if="configsLocal">
                            <div class="form-group mb-2">
                              <label class="small mb-0">Após finalizar pedido:</label>
                              <select class="form-control" v-model="configsLocal.mostrar_comanda">
                                <option value="0">Manter a venda aberta</option>
                                <option value="1">Abrir as mesas ou comandas</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-5">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h5 class="mb-0">Termos Rápidos</h5>
                  <div class="visibility">
                    <button class="btn btn-dark btn-secondary px-4">Oie</button>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <termos-rapidos/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="menu === 3">
            <div class="row">
              <div class="col-lg-7 mb-3 mb-lg-0">
                <div class="card">
                  <div class="card-body">
                    <div v-if="cozinhas.length">
                      <div class="text-right mb-3">
                        <button :disabled="cozinhaCad" class="btn btn-secondary btn-sm" @click="cadastrarCozinha"><i class="fa fa-plus mr-1"></i> Cadastrar</button>
                      </div>
                      <div class="mt-1" v-for="(c, i) in cozinhas">
                        <div class="border-top">
                          <div class="row align-items-center">
                            <div class="col-sm-6 col-lg-5 pointer" @click="editarCozinha(c)">
                              <div class="py-2">
                                {{c.nome_cozinha}} <i class="fa fa-edit text-primary ml-1 small"></i>
                              </div>
                            </div>
                            <div class="col-sm-6 col-lg-7 text-sm-right">
                              <div class="py-1 text-nowrap">
                                <button :class="c.fg_ativo === '1' ? 'btn-secondary' : 'btn-light'" class="btn btn-sm mr-1" @click="toggleCozinha(c, '1')">Ativado</button>
                                <button :class="c.fg_ativo === '2' ? 'btn-secondary' : 'btn-light'" class="btn btn-sm" @click="toggleCozinha(c, '2')">Desativado</button>
                                <button class="btn btn-dark ml-3" @click="deletarCozinha(c)"><i class="fa fa-trash-alt"></i></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="py-5 text-center" v-else>
                      <h5 class="mb-1">Cadastrar Cozinhas</h5>
                      <p class="mx-auto mb-4" style="max-width: 600px">Cadastre as cozinhas para usar como monitor de preparo e vincular os seus produtos com as suas impressoras de pedidos.</p>
                      <button :disabled="cozinhaCad" class="btn btn-secondary" @click="cadastrarCozinha">Cadastrar</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="mostrarMenuImpressoras && menu === 4">
            <config-impressao-nova :printers="printers"/>
          </div>

          <div v-if="menu === 5">
            <div class="row">
              <div class="col-lg-6" v-if="isElectron">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h5>Monitor LeCard</h5>
                  <div>
                    <div class="d-inline-block pointer text-nowrap pr-2" @click="toggleMonitor()">
                      <span class="d-none d-md-inline-block pr-2" :class="acbrMonitor.habilitar ? 'text-success' : 'text-secondary'">{{acbrMonitor.habilitar ? 'Ativado' : 'Desativado'}}</span>
                      <img class="switch" src="../../assets/icons/switch-on.svg" v-show="acbrMonitor.habilitar">
                      <img class="switch" src="../../assets/icons/switch-off.svg" v-show="!acbrMonitor.habilitar">
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <p class="small mb-2">
                      Para habilitar a integração com a Balança Digital, Gaveta de Dinheiro e Emissão de Cupom Fiscal, é necessário instalar o <b>Monitor LeCard</b> no seu computador.
                      Após realizar o procedimento de instalação, habilite-o aqui nesta página e informe a pasta de integração (compatível com Windows 7 ou superior).
                    </p>
                    <a :href="base_cdn + '/downloads/lecardmonitor.exe'" download="true"><i class="fa fa-download"></i> Download</a>
                    <div class="row mt-2">
                      <div class="col-md-8">
                        <div class="form-group mb-2">
                          <label class="mb-0 small">Pasta da Integração</label>
                          <input v-model="acbrMonitor.path" id="pathMonitor" class="form-control" placeholder="Ex: C:\LeCardMonitor"/>
                          <div class="small mt-1">Caminho da pasta do LeCard Monitor</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <h5 class="mb-3">Desenvolvedor</h5>
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="m-0">Servidor em uso</h6>
                      <span
                        :class="is_homolog ? 'badge-info' : (is_fallback ? 'badge-warning' : 'badge-success')"
                        class="badge badge-pill"
                      >
                        {{ is_homolog ? 'Homologação' : (is_fallback ? 'Alternativo' : 'Principal') }}
                      </span>
                    </div>
                    <hr>
                    <div v-if="master && isElectron">
                      <div class="d-flex justify-content-between align-items-center">
                        <h6 class="m-0">Modo Desenvolvedor</h6>
                        <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:" @click="toggleAmbiente()">
                          <span class="small mr-2">{{ modo_teste ? 'Ativado' : 'Desativado' }}</span>
                          <img class="switch" src="../../assets/icons/switch-on.svg" v-show="modo_teste" alt="Ativado"/>
                          <img class="switch" src="../../assets/icons/switch-off.svg" v-show="!modo_teste" alt="Desativado"/>
                        </a>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="m-0">Mostrar Piloto automatico</h6>
                      <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:" @click="togglePiloto()">
                        <span class="small mr-2">{{ show_piloto ? 'Ativado' : 'Desativado' }}</span>
                        <img class="switch" src="../../assets/icons/switch-on.svg" v-show="show_piloto" alt="Ativado"/>
                        <img class="switch" src="../../assets/icons/switch-off.svg" v-show="!show_piloto" alt="Desativado"/>
                      </a>
                    </div>
                    <div>
                      <hr>
                      <img src="../../assets/icons/ifood.svg" alt="Logo iFood" class="mb-3" style="width: 42px">
                      <div>
                        <label class="mb-2">
                          <input type="checkbox" @change="toggleLogs()" :checked="$store.state.logsIfood">
                          Habilitar logs
                        </label>
                      </div>
                      <div class="mb-2">
                        <label class="mb-0">
                          <input type="checkbox" @change="toggleChatIfood()" :checked="showChatIfood">
                          Habilitar Chat iFood
                        </label>
                      </div>
                      <div class="mb-2">
                        <label class="mb-0">
                          <input :checked="ifoodPollingV2" type="checkbox" @change="toggleIfoodPollingV2()">
                          Usar nova regra de polling do iFood
                        </label>
                      </div>
                    </div>
                    <hr>
                    <div>
                      <h6 class="text-danger mb-0">Danger zone</h6>
                      <p class="mb-2 small">Limpar todas as configurações salvas</p>
                      <button class="btn btn-primary" @click="resetar" style="width: 200px">Resetar sistema</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal :opened="modalCozinha" no-pad="true">
      <cozinha @salvar="buscarCozinhas" @fechar="modalCozinha = false" :printers="printers"/>
    </modal>
  </div>
</template>

<script>
  import TopBar from '@/components/commons/TopBar.vue'
  import Loading from "../../components/gestor/loading";
  import Cozinha from "../../components/gestor/Cozinha";
  import Modal from "../../components/gestor/ModalGestor";
  import TermosRapidos from "@/views/comanda/pdv/TermosRapidos";
  import Tooltip from "@/components/commons/Tooltip";
  import ModalMenu from "@/components/commons/ModalMenu";
  import ConfigImpressaoNova from "@/components/configs/impressao/ConfigImpressaoNova";

  export default {
    name: 'Home',
    components: {
      ModalMenu,
      ConfigImpressaoNova,
      Tooltip,
      TermosRapidos,
      Modal,
      Cozinha,
      Loading,
      TopBar
    },
    data() {
      return {
        atualizar: false,
        token: localStorage.getItem('key'),
        load: false,
        config: {
          device: '',
          devicePdv: '',
          automatico: '1',
          nCopias: '1',
          zoom: '1',
          margin: 'auto',
          largura: '',
          chat_lecard: '0',
          printCashier: '0',
          printCashierPdv: '0',
        },
        modo_teste: false,
        show_piloto: false,
        ifoodPollingV2: false,
        showChatIfood: false,
        printServer: false,
        printRemoto: false,
        silenciar: false,
        openInNewPage: false,
        hideGestor: false,
        terminal: false,
        modoLista: false,

        menu: 1,
        cozinhas: [],
        cozinhaSel: null,
        cozinhaCad: false,
        modalCozinha: false,

        showSenha: false,
        impressoraPdv: "",
        impressoraPedidos: "",
        som_pedidos: 'bell',
        som_notificacao: 'bell',
        audio: null,

        configsLocal: null,
        configsPdv: {
          qtd_mesas: 0,
          qtd_comandas: 0,
          habilitar_caixa: '',
          importar_lecard: '',
          unidade_medida: 1,
          notificar_pdv: 1,
          taxa_servico: 0,
          valor_frete: 0,
          automatico: 0,
          json_config: {}
        },

        timeOutAcbr: null,
        acbrMonitor: {
          habilitar: false,
          path: 'C:\\ACBrMonitorPLUS'
        }
      }
    },

    methods: {
      toggleMenu(m) {
        this.menu = m;

        if (m === 3 && !this.cozinhas.length) {
          this.buscarCozinhas();
        }
      },

      atualizarConfig() {
        localStorage.removeItem('impressoraPdv');
        localStorage.removeItem('impressoraPedidos');
        localStorage.removeItem('unPrintPdv');
        localStorage.removeItem('printRemoto');
        localStorage.removeItem('printCashier');

        if (this.printServer) {
          this.config.printServer = (window.gPConfigs || {}).host || null;

        } else {
          localStorage.setItem('unPrintPdv', '1');

          if (this.printRemoto) {
            localStorage.setItem('printRemoto', '1');

          } else {
            if (this.impressoraPdv) {
              localStorage.setItem('impressoraPdv', this.impressoraPdv);
              this.$store.state.impressora.devicePdv = this.impressoraPdv;
            }

            if (this.impressoraPedidos) {
              localStorage.setItem('impressoraPedidos', this.impressoraPedidos);
              this.$store.state.impressora.device = this.impressoraPedidos;
            }
          }

          if (this.$store.state.ifoodAtivo) {
            document.dispatchEvent(new CustomEvent('ifoodPolling', { detail: { pause: true } }));
          }
        }

        const printConfig = JSON.stringify(this.config);
        const chat_lecard = this.user.chat_lecard === '0' ? '2' : '1';
        this.load = true;

        this.$http.post('delivery/config/' + this.token, { printConfig, chat_lecard })
          .then(res => {
            this.load = false;

            if (res.data && res.data.success) {
              this.$cache.remove('usuario');
              this.$swal("Configurações editadas com sucesso!").then(() => {
                window.location.reload();
              });

            } else {
              this.$swal('Erro ao atualizar!');
            }

          }, res => {
            this.load = false;
            this.$swal(res.data.msg);
          });
      },

      salvarConfigsPdv() {
        this.$store.state.load = true;
        this.configsPdv.qtd_mesas = this.configsPdv.qtd_mesas < 127 ? this.configsPdv.qtd_mesas : 127;
        this.configsPdv.qtd_comandas = this.configsPdv.qtd_comandas < 127 ? this.configsPdv.qtd_comandas : 127;

        this.$http.post("pdv/configs/" + this.token, this.configsPdv)
          .then(res => {
            this.$store.state.load = false;

            if (res.data && res.data.success) {
              this.$store.commit('setConfigs', this.configsPdv);
              this.$cache.set('configs', this.configsPdv);

              this.$store.state.configsLocal = this.configsLocal;
              localStorage.setItem('configsLocal', JSON.stringify(this.configsLocal));

              this.$swal('Configurações editadas com sucesso!');

            } else {
              this.$swal('Erro ao atualizar!');
            }

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          });
      },

      buscarConfigs() {
        this.load = true;
        this.cozinhas = [];

        this.$http.get('pdv/configs/' + this.token)
          .then(response => {
            this.load = false;

            if (response.data) {
              this.configsPdv = response.data;
              const cf = (JSON.parse(this.configsPdv.printConfig) || {});

              this.config = {
                device: cf.device || '',
                devicePdv: cf.devicePdv || '',
                automatico: cf.automatico || '1',
                nCopias: cf.nCopias || '1',
                zoom: cf.zoom || '9px',
                largura: cf.largura || '',
                margin: cf.margin || 'auto',
                printServer: cf.printServer || null,
                mobilePrint: cf.mobilePrint || '0',
                printCashier: (localStorage.getItem('printCashier') || cf.printCashier || '0'),
                printCashierPdv: cf.printCashierPdv || '0'
              };

              this.printServer = !localStorage.getItem('unPrintPdv') && (window.gPConfigs || {}).host === this.config.printServer;
              this.toggleMenu(this.menu);
            }

          }, res => {
            this.load = false;

            if (res.status === 401) {
              this.logout(true);

            } else {
              this.$swal(res.data.msg || 'Erro ao buscar as configs');
            }
          });
      },

      resetar() {
        this.$swal({
          text: "Deseja resetar o sistema?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            localStorage.clear();
            sessionStorage.clear();
            window.location.reload();
          }
        });
      },

      confirmLogout() {
        this.$swal({
          text: "Deseja sair do sistema?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            this.logout(true);
          }
        });
      },

      atualizarSom() {
        if (this.silenciar) {
          localStorage.setItem('silenciar','1');

        } else {
          localStorage.removeItem('silenciar');
        }

        if (this.som_pedidos !== 'bell') {
          localStorage.setItem('som_pedidos', this.som_pedidos);

        } else {
          localStorage.removeItem('som_pedidos');
        }

        if (this.som_notificacao !== 'bell-4') {
          localStorage.setItem('som_notificacao', this.som_notificacao);

        } else {
          localStorage.removeItem('som_notificacao');
        }

        window.location.reload();
      },

      playSom(tipo) {
        if (this.audio && !this.audio.paused) {
          this.audio.pause()
        }

        const bell = `${tipo === 1 ? this.som_pedidos : this.som_notificacao}`;
        this.audio = new Audio(`./audios/${bell}.mp3`);

        this.audio.play().then().catch(() => {
          this.$swal("Não foi possível tocar a notificação.");
        });
      },

      toggleNewPage() {
        this.$swal({
          text: `Deseja salvar esta configuração?`,
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            if (this.openInNewPage) {
              localStorage.removeItem('openInNewPage');

            } else {
              localStorage.setItem('openInNewPage','1');
            }

            window.location.reload();
          }
        });
      },

      toggleHideGestor() {
        this.$swal({
          text: `Deseja salvar esta configuração?`,
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            if (this.hideGestor) {
              localStorage.removeItem('isComanda');

            } else {
              localStorage.setItem('isComanda','1');
            }

            window.location.reload();
          }
        });
      },

      toggleTerminal() {
        if (!this.terminal) {
          localStorage.removeItem('isTerminal');

        } else {
          localStorage.setItem('isTerminal', this.terminal);
        }

        this.$store.state.isTerminal = this.terminal;
      },

      toggleChatLecard() {
        this.$store.state.dataUser.chat_lecard = (this.user.chat_lecard === '1' ? '0' : '1');
        this.atualizarConfig();
      },

      toggleModoGestor() {
        if (this.modoLista) {
          this.modoLista = false;
          localStorage.removeItem('modoLista');

        } else {
          this.modoLista = true;
          localStorage.setItem('modoLista','1');
        }
      },

      toggleAmbiente() {
        this.$swal({
          text: "Deseja " + (this.modo_teste ? "desativar" : "ativar") + " o Modo Desenvolvedor?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            document.dispatchEvent(new CustomEvent('setAmbiente', { detail: !this.modo_teste ? '3' : '' }));
          }
        });
      },

      togglePiloto() {
        this.show_piloto = !this.show_piloto;

        if (this.show_piloto) {
          localStorage.setItem('showPiloto', '1');

        } else {
          this.$store.state.pilotoAutomatico = false;
          localStorage.removeItem('showPiloto');
          localStorage.removeItem('pilotoAutomatico');
        }
      },

      buscarCozinhas() {
        this.load = true;
        this.modalCozinha = false;

        this.$http.get('cozinhas/' + this.token)
          .then(response => {
            this.cozinhas = response.data;
            this.load = false;

          }, res => {
            this.load = false;
            this.$swal(res.data.msg);
          });
      },

      editarCozinha(c) {
        this.$emit('openModal', c);
        this.modalCozinha = true;
      },

      toggleCozinha(c, status) {
        c.fg_ativo = status;
        this.$http.post('cozinhas/' + this.token, c)
          .then(response => {
          }, res => {
            this.load = false;
            this.$swal(res.data.msg);
          });
      },

      deletarCozinha(c) {
        this.$swal({
          text: "Deseja deletar esta cozinha?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            this.load = true;
            this.$http.post('cozinhas/deletar/' + this.token, c)
              .then(res => {
                this.load = false;

                if (res.data && res.data.success) {
                  this.$swal("Cozinha deletada com sucesso!");
                  this.buscarCozinhas();
                }
              }, res => {
                this.load = false;
                this.$swal(res.data.msg);
              });
          }
        });
      },

      cadastrarCozinha() {
        const novo = {
          nome_cozinha: 'Cozinha',
          device: null,
          imprimir: '1',
          print_delivery: '1',
          fg_ativo: '1',
          categorias: []
        };

        this.editarCozinha(novo);
      },

      toggleLogs() {
        this.$store.state.logsIfood = !this.$store.state.logsIfood;

        if (this.$store.state.logsIfood) {
          localStorage.setItem('logsIfood', '1');

        } else {
          localStorage.removeItem('logsIfood');
        }
      },

      toggleChatIfood() {
        if (this.showChatIfood) {
          this.showChatIfood = false;
          this.$store.state.chatIfood = false;
          localStorage.setItem('hideChatIfood', '1');

        } else {
          this.showChatIfood = true;
          localStorage.removeItem('hideChatIfood');
          document.dispatchEvent(new CustomEvent('ifoodWidget'));
        }
      },

      toggleIfoodPollingV2() {
        this.ifoodPollingV2 = !this.ifoodPollingV2;

        if (this.ifoodPollingV2) {
          localStorage.setItem('ifoodPollingV2', '1');
        } else {
          localStorage.removeItem('ifoodPollingV2');
        }

        window.location.reload();
      },
      toggleMonitor() {
        const regex = new RegExp('^[a-z]:(\/|\\\\)([a-zA-Z0-9_ \-]+\\1)*[a-zA-Z0-9_ @\-]', 'i');

        if (!this.acbrMonitor.habilitar) {
          if (!regex.test(this.acbrMonitor.path)) {
            this.$swal("Por Favor, informe um caminho válido!").then(() => {
              this.$helpers.focusElement('pathMonitor');
            });

            return;
          }

          window.acbrFolder = this.acbrMonitor.path;
          this.$store.state.load = "Aguardando comunicação";

          this.timeOutAcbr = setTimeout(() => {
            this.$store.state.load = false;
            this.$swal('Não foi possível fazer a comunicação com o Monitor LeCard, verifque o caminho informado e tente novamente.').then(() => {
              this.acbrMonitor.habilitar = false;
              window.acbrFolder = null;
              this.$helpers.focusElement('pathMonitor');
            });
          }, 8000);

          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('comandoAcbr', { detail: "ACBr.datahora" }));
          }, 1000);

        } else {
          this.acbrMonitor.habilitar = false;
          localStorage.removeItem('acbrFolder');
          window.acbrFolder = null;
        }
      },

      acbrReply(e) {
        this.$store.state.load = false;

        if (e.detail && e.detail.startsWith('OK:')) {
          clearTimeout(this.timeOutAcbr);
          localStorage.setItem('acbrFolder', this.acbrMonitor.path);
          this.acbrMonitor.habilitar = true;
          this.$swal("Monior LeCard ativado com sucesso!");
        }
      },

      getPrinters() {
        document.dispatchEvent(new CustomEvent('getPrinters'));
        this.$store.state.load = "Aguarde..";
        setTimeout(() => {
          this.$store.state.load = false;
          this.$swal("Impressoras sincronizadas com sucesso!");
        }, 2000);
      }
    },

    mounted() {
      window.scrollTo(0, 0);
      this.silenciar = localStorage.getItem('silenciar') === '1';
      this.openInNewPage = localStorage.getItem('openInNewPage') === '1';
      this.hideGestor = localStorage.getItem('isComanda') === '1';
      this.terminal = localStorage.getItem('isTerminal') || '';
      this.modoLista = localStorage.getItem('modoLista') === '1';
      this.show_piloto = localStorage.getItem('showPiloto') === '1';
      this.showChatIfood = localStorage.getItem('hideChatIfood') !== '1';
      this.ifoodPollingV2 = localStorage.getItem('ifoodPollingV2') === '1';
      this.printRemoto = localStorage.getItem('printRemoto');
      this.impressoraPedidos = localStorage.getItem('impressoraPedidos') || '';
      this.impressoraPdv = localStorage.getItem('impressoraPdv') || '';
      this.som_pedidos = localStorage.getItem('som_pedidos') || 'bell';
      this.som_notificacao = localStorage.getItem('som_notificacao') || 'bell-4';
      this.configsLocal = this.$store.state.configsLocal;

      if (this.isElectron && localStorage.getItem('acbrFolder')) {
        this.acbrMonitor.habilitar = true;
        this.acbrMonitor.path = localStorage.getItem('acbrFolder');
      }

      if (this.user.id_funcao <= 2) {
        this.buscarConfigs();
      }
    },

    created() {
      document.addEventListener("acbrReply", this.acbrReply, false);
      this.modo_teste = !!this.is_homolog;
    },

    computed: {
      menus() {
        return [
          { nome: 'Sistema', active: true },
          { nome: 'PDV', active: this.user.id_funcao === '1' },
          { nome: 'Cozinhas', active: true },
          { nome: 'Impressoras', active: this.mostrarMenuImpressoras },
          { nome: 'Desenvolvedor', active: true }
        ];
      },

      mostrarMenuImpressoras() {
        return this.master || Number(this.$store.state.configImpressao.migrado_legado || 0) === 1;
      },

      adm() {
        return this.$store.state.dataUser.id_funcao === '1'
      },

      user() {
        return this.$store.state.dataUser
      },

      master() {
        return this.$store.state.dataUser.master
      },

      isComanda() {
        return this.$store.state.is_comanda;
      },

      printers() {
        return this.$store.state.printers;
      }
    },

    beforeDestroy() {
      document.removeEventListener("acbrReply", this.acbrReply);
    }
  }
</script>
